<template>
  <div class="head-box">
    <div class="left-block">
      <img src="@/assets/img/head/icon.png" alt />
    </div>
    <div class="right-block account-menu">
      <el-menu
      text-color="#000000"
        active-text-color="#007AFF"
        :default-active="activeRouter"
        mode="horizontal"
        unique-opened
        router
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-submenu index="2" >
          <template slot="title">产品服务</template>
          <el-menu-item index="/service">广告主服务</el-menu-item>
          <el-menu-item index="/taobaoAlliance">淘宝联盟</el-menu-item>
        </el-submenu>
        <el-menu-item index="/partners">合作伙伴</el-menu-item>
        <el-menu-item index="/join">加入我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      activeRouter: "" //默认选中路由
    };
  },

  watch: {
    $route(to, from) {
      this.activeRouter = to.path; //切换选中路由
    }
  }
};
</script>

<style scoped lang="scss">
.el-menu.el-menu--horizontal {
  border-bottom-width: 0px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom-width: 0px;
}
.el-menu--horizontal > .el-menu-item {
  border-bottom-width: 0px;
  font-size: 16px;
}
.el-menu--horizontal > .el-menu-item.is-active::after {
  content: " ";
  width: 30px;
  height: 4px;
  background: #007AFF;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%); //居中处理
}



.el-menu--horizontal > .el-submenu.is-active /deep/ .el-submenu__title{
  border-bottom-width: 0px;
  font-size: 16px;
}
.el-menu--horizontal > .el-submenu /deep/ .el-submenu__title{
  border-bottom-width: 0px;
  font-size: 16px;
}

.el-menu--horizontal > .el-submenu.is-active /deep/ .el-submenu__title::after{
  content: " ";
  width: 30px;
  height: 4px;
  background: #007AFF;
  position: absolute;
  bottom: 10px;
  left: 42%;
  transform: translateX(-50%); //居中处理
}

.head-box {
  padding: 10px 0px;
  background: white;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .account-menu {
    width: 408px;
    line-height: 44px;
    flex-shrink: 0;
    .herf {
      font-weight: bold;
      color: #fff;
      &.router-link-exact-active {
        color: #007aff;
      }
    }
  }
}

.left-block {
  margin-left: 220px;
}

.right-block {
  margin-right: 250px;
}

.left-block img {
  margin-top: 15px;
}
.el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
  min-width: 132px;
  text-align: center;
}
</style>
